var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._l(_vm.definedItems, function (product, index) {
      return _c("div", { key: "product_" + index }, [
        _c(
          "div",
          {
            staticClass: "pseudo-selector",
            class: {
              "pseudo-selector--with-flex":
                product.directChildrenObjs && product.directChildrenObjs.length,
              "pseudo-selector--active":
                _vm.internalSelectionState[product.id] &&
                _vm.internalSelectionState[product.id] === "Selected",
              "pseudo-selector--fuzzy":
                _vm.internalSelectionState[product.id] &&
                _vm.internalSelectionState[product.id] === "Fuzzy",
            },
            style: _vm.getPseudoSelectorStyling(),
            on: {
              click: function ($event) {
                return _vm.selectInChild(product)
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "select-item__left",
                attrs: { title: product.display },
              },
              [
                _c("div", {
                  staticClass: "pseudo-selector__checkbox",
                  style: _vm.getPseudoCheckboxStyling(),
                }),
                _vm._v(
                  " " +
                    _vm._s(
                      product.displayHierarchy || product.display || product.id
                    ) +
                    " "
                ),
              ]
            ),
            product.directChildrenObjs && product.directChildrenObjs.length
              ? _c(
                  "div",
                  {
                    staticClass: "select-item__right",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        _vm.expandedMap[product.id] =
                          !_vm.expandedMap[product.id]
                      },
                    },
                  },
                  [
                    !_vm.expandedMap[product.id]
                      ? _c("i", { staticClass: "material-icons" }, [
                          _vm._v("expand_more"),
                        ])
                      : _vm._e(),
                    _vm.expandedMap[product.id]
                      ? _c("i", { staticClass: "material-icons" }, [
                          _vm._v("expand_less"),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]
        ),
        product.directChildrenObjs && product.directChildrenObjs.length
          ? _c(
              "div",
              {
                staticClass: "collapsible-container",
                class: {
                  "collapsible-container--expanded":
                    _vm.expandedMap[product.id],
                },
              },
              [
                _c("ProductTreeLevel", {
                  attrs: {
                    level: product.level + 1,
                    items: product.directChildrenObjs,
                    internalSelectionState: _vm.internalSelectionState,
                    filter: _vm.filter,
                  },
                  on: {
                    select: function ($event) {
                      return _vm.selectInChild($event)
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }